// cSpell:ignore flexbox, STYuanti, Unmount

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import ProgressBar from '../../lib/components/LessonPath/lesson-progress-bar';
import { Flex, LessonTag, LessonTitle, EllipsisTwoCell } from '../../lib/components/LessonPath/static/style';

import ChooseLevel from '../../components/dialog/ChooseLevel';
import { getNeedShowChooseLevel } from '../../server/commonFun';
import utils from '../../lib/utils';

export default class Lessons extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showChooseLevel: false
        }
    }

    componentDidMount() {
        const that = this;
        window.addEventListener('mousewheel', that.onScrollHandler);
        window.addEventListener('DOMMouseScroll', that.onScrollHandler);
    }

    componentWillUnmount() {
        const that = this;
        window.removeEventListener('mousewheel', that.onScrollHandler);
        window.removeEventListener('DOMMouseScroll', that.onScrollHandler);
    }

    buttonClickHandler(url, item) {
        const that = this;

        if (url && url.indexOf('https://www.putaoabc.com/ai_course/#/path') > -1) { // 如果是要去主课路径页，就只取hash值，防止页面缓存
            url = url.replace('https://www.putaoabc.com/ai_course/', '');
        }

        if (item && item.cardType && item.cardType === 'major') {
            getNeedShowChooseLevel(that.context.user).then(res => {
                if (res.code && res.code === 200 && res.data && res.data.residueCourseNum) {
                    that.setState({ showChooseLevel: true, levelInfo: res.data })
                } else if (url) {
                    window.location.href = url;
                }
            });
        } else if (url) {
            if (item && item.cardType && item.cardType === 'ctLesson') {
                window.location.href = url + '&' + utils.setJsonToUrl(that.context.user);
            } else {
                window.location.href = url;
            }
        }
    }

    // 点击关闭开通课程
    handleChooseLevelClose() {
        this.setState({ showChooseLevel: false });
    }

    render() {
        const { data } = this.props;
        const { showChooseLevel, levelInfo } = this.state;

        return (
            <CardBox>
                {data && Array.isArray(data) && data.map((item, index) =>
                    <CardItem key={index} type={!item.cardImgURL ? 'normal' : ''}>
                        {item.cardImgURL && <CardImg src={item.cardImgURL} alt='' />}
                        {item.cardTag &&
                            <LessonTag
                                type={index}
                                long={item.cardType && item.cardType === 'ctLesson' ? true : false}>
                                {item.cardTag}
                            </LessonTag>}
                        {item.cardTitle && <LessonNumber>{item.cardTitle}</LessonNumber>}
                        {item.cardContent &&
                            <LessonContent>
                                <EllipsisTwoCell>{item.cardContent}</EllipsisTwoCell>
                            </LessonContent>}
                        {item.lessonStatus &&
                            <ProgressBar
                                style={getProgressStyled(item.cardType)}
                                data={getProgressData(item)}
                            />}
                        {item.cardButton &&
                            <CardBottom
                                type={item.cardType}
                                content={item.cardButton && item.cardButton.buttonContent ? item.cardButton.buttonContent : null}
                                onClick={() => this.buttonClickHandler(item.cardButton.buttonPageURL ? item.cardButton.buttonPageURL : null, item)}
                            >
                                {item.cardButton.buttonContent ? item.cardButton.buttonContent : '更多内容'}
                            </CardBottom>}
                    </CardItem>)}
                {showChooseLevel && levelInfo &&
                    <ChooseLevel
                        data={levelInfo}
                        successChooseLevelHandler={this.handleChooseLevelClose.bind(this)}
                        clickCloseHandler={this.handleChooseLevelClose.bind(this)}
                    />
                }
            </CardBox>
        );
    }
}

Lessons.contextTypes = {
    user: PropTypes.object
}

const getProgressStyled = (type) => {
    const style = {
        'transform': `scale(0.85)`,
        'WebkitTransform': `scale(0.85)`,
    };

    style.width = type === 'ctLesson' ? '55%' : '70%';

    return style;
}

const getProgressData = (data) => {
    const barData = [];

    if (!data) {
        return barData;
    }

    if (data.cardType && data.cardType === 'ctLesson') {
        barData.push({
            text: '单元总结',
            status: data.lessonStatus ? data.lessonStatus.summary : false
        }, {
            text: '学习',
            status: data.lessonStatus ? data.lessonStatus.lesson : false
        });
    } else if (data.cardType && data.cardType === 'expandLesson') {
        barData.push({
            text: '学习',
            status: data.lessonStatus ? data.lessonStatus.lesson : false
        }, {
            text: '练一练',
            status: data.lessonStatus ? data.lessonStatus.homework : false
        });
    } else {
        barData.push({
            text: '预习',
            status: data.lessonStatus ? data.lessonStatus.preview : false
        }, {
            text: '学习',
            status: data.lessonStatus ? data.lessonStatus.lesson : false
        }, {
            text: '练一练',
            status: data.lessonStatus ? data.lessonStatus.homework : false
        });
    }

    return barData;
}

const getButtonColor = (type, content) => {
    let color;
    switch (type) {
        // case 'levelExam':
        //     color = 'linear-gradient(to right bottom, #FFAB90, #FF615C)';
        //     break;
        case 'web':
            color = 'linear-gradient(to right, #FFB130, #FF7800)';
            break;
        default: color = '#BC61FF'
    }

    if (content && content.indexOf('学习') > -1) {
        color = '#4BAA5F'
    }

    return color;
}

const CardBox = styled(Flex)`
    width: 100%;
    height: 4.5rem;
    margin-top: 0.5rem;
    justify-content: center;
    align-items: flex-end;
`;

const CardItem = styled.div`
    position: relative;
    width: 3.68rem;
    min-height: 3.54rem;
    margin: 0 0.32rem;
    flex: none;

    ${props => props.type && props.type === 'normal' ? `
        background: url(${require('../../static/img/index/card-bg.png')}) no-repeat bottom;
        background-size: contain;
    ` : ''}
`;

const CardImg = styled.img`
    position: absolute;
    width: 100%;
    bottom: 0;
`;

const CardBottom = styled.div`
    position: absolute;
    bottom: 0.24rem;
    left: 50%;
    transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    width: 2.64rem;
    height: 0.61rem;
    background: ${props => getButtonColor(props.type, props.content)};
    border-radius: 0.3rem;
    line-height: 0.61rem;
    text-align: center;
    color: #fff;
    font-size: 0.29rem;
    font-family: PingFangSC-Regular,PingFang SC;
    font-weight: 400;
    cursor: pointer;
`;

const LessonNumber = styled.div`
    margin-top: 0.6rem;
    text-align: center;
    font-size: 0.26rem;
    font-family:STYuanti-SC-Regular,STYuanti-SC;
    font-weight:400;
    color: #9187A0;
    line-height: 0.3rem;
    height: 0.4rem;
`;

const LessonContent = styled(LessonTitle)`
    color: #951BD0;
    font-size: 0.35rem;
    font-family:STYuanti-SC-Bold,STYuanti-SC;
    font-weight:bold;
`;

// cardType:卡片类型 类型有(major, ctLesson, readingLesson, trialLesson,expandLesson,systemLesson,specialTraining,levelExam, web



// WEBPACK FOOTER //
// ./src/components/index/index-card.js